export type WindowScroll = {
  scrollX: number;
  scrollY: number;
};

export function getWindowScroll(): WindowScroll {
  return { scrollX: window.pageXOffset, scrollY: window.pageYOffset };
}
